// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ParticipantView__fullScreen-c431ff {
  display: flex;
}

.ParticipantView__container-bed466 {
  display: flex;
  flex: 1;
  position: relative;
  width: 100%;
  background: var(--addition-40);
  height: 100%;
  box-sizing: border-box;
  justify-content: center;
}

.ParticipantView__main-f0642b {
  padding: 8px;
  position: relative;
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.ParticipantView__speaker-f566a5 {
  position: relative;
  display: flex;
  flex: 1;
}

.ParticipantView__streamers-ae28b2 {
  position: relative;
}

.ParticipantView__meta-e0d83a {
  top: 8px;
}

.ParticipantView__secondary-bec017 {
  position: absolute;
  bottom: 64px;
  inset-inline-end: 8px;
  overflow: visible;
}

.ParticipantView__secondary-bec017 > div {
  overflow: visible;
}

.ParticipantView__secondary-bec017 video {
  width: 100% !important;
  max-width: 240px;
  height: auto !important;
  position: static !important;
}

.ParticipantView__button-e086ba {
  margin-top: 20px;
}

.ParticipantView__finished-f64594 {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--addition-40_60);
  color: var(--addition-50);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}

.ParticipantView__finish-title-c33240 {
  color: var(--addition-50);
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/ParticipantView/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,OAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,2CAAA;AACF","sourcesContent":[".fullScreen {\n  display: flex;\n}\n\n.container {\n  display: flex;\n  flex: 1;\n  position: relative;\n  width: 100%;\n  background: var(--addition-40);\n  height: 100%;\n  box-sizing: border-box;\n  justify-content: center;\n}\n\n.main {\n  padding: 8px;\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n}\n\n.speaker {\n  position: relative;\n  display: flex;\n  flex: 1;\n}\n\n.streamers {\n  position: relative;\n}\n\n.meta {\n  top: 8px;\n}\n\n.secondary {\n  position: absolute;\n  bottom: 64px;\n  inset-inline-end: 8px;\n  overflow: visible;\n}\n\n.secondary > div {\n  overflow: visible;\n}\n\n.secondary video {\n  width: 100% !important;\n  max-width: 240px;\n  height: auto !important;\n  position: static !important;\n}\n\n.button {\n  margin-top: 20px;\n}\n\n.finished {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--addition-40_60);\n  color: var(--addition-50);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n\n.finish-title {\n  color: var(--addition-50);\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullScreen": `ParticipantView__fullScreen-c431ff`,
	"container": `ParticipantView__container-bed466`,
	"main": `ParticipantView__main-f0642b`,
	"speaker": `ParticipantView__speaker-f566a5`,
	"streamers": `ParticipantView__streamers-ae28b2`,
	"meta": `ParticipantView__meta-e0d83a`,
	"secondary": `ParticipantView__secondary-bec017`,
	"button": `ParticipantView__button-e086ba`,
	"finished": `ParticipantView__finished-f64594`,
	"finish-title": `ParticipantView__finish-title-c33240`,
	"finishTitle": `ParticipantView__finish-title-c33240`
};
module.exports = ___CSS_LOADER_EXPORT___;
